import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { AnyDate, formatDateTime, parseDateTime, TimeFormats } from '../../helpers/dateHelper'
import { Text, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'

type Props = {
    date: AnyDate
    format?: TimeFormats
    className?: string
}

export default function FormattedDateTime(props: Props): ReactElement {
    const { i18n } = useTranslation()

    const dateString = useMemo(() => formatDateTime(props.date, { locale: i18n.language }), [i18n.language])
    const tooltipString = useMemo(
        () => parseDateTime(props.date, { locale: i18n.language })?.toFormat(props.format || TimeFormats.Full) || '',
        [i18n.language],
    )

    return (
        <Tooltip relationship={'label'} content={tooltipString} withArrow>
            <Text size={200} className={props.className}>
                {dateString}
            </Text>
        </Tooltip>
    )
}
